<template>
  <section id="poRecap" class="fixed bottom-0 left-0 right-0 bg-black c-white z-100 h-screen lg:h-auto" :class="{ 'state-full screeb-recap': parcours.etape == 5 }" :style="{ transform: isRecapActive ? 'translateY(0)' : `translateY(calc(100% - ${heightRecap}px))`  }">
    <div id="poRecap__header" class="py-14 lg:py-24">
      <div class="container dflex dflex-col lg:dflex-row lg:items-center justify-between lg:justify-start lg:gap-10 relative">
        <div id="recapTooltip" class="infoToolTip__content px-25 richContent c-black" :class="{ 'hidden!': parcours.hideTool == 1 }">
          <button @click="hideTool()" class="jsCloseMe absolute right-10 top-10 pointer p-5" type="button"><span class="sr-only">Fermer</span><span class="w-20 h-20 block"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 27 27" aria-hidden="true"><path fill="currentColor" d="M21.0947 8.0752 15.6699 13.5l5.4248 5.4248-2.1699 2.1699L13.5 15.6699l-5.4248 5.4248-2.17-2.1699L11.3302 13.5 5.9053 8.0752l2.1699-2.17L13.5 11.3302l5.4248-5.4248z"/></svg></span></button>
          <p class="font-bold mb-5">Configurateur Open</p>
          <p>Consultez le détail de votre Pack</p>
        </div>
        <div class="dflex items-center gap">
          <p class="text-bold text-xl lg:text-3xl leading-24 lg:leading-34">
            Votre Pack Open
            <template v-if="data_etape5 && data_etape5.serviceselection && parcours.etape >= 4">
              <template v-for="(service, indexservice) in data_etape5.serviceselection" :key="indexservice">{{ service.field_type_de_forfait[0] + ' ' }} </template>
            </template>
            <template v-if="data_etape5 && data_etape5.packopen && Object.keys(data_etape5.packopen).length > 0 && parcours.etape >= 4">
              <template v-for="(packopen, indexpackopen) in data_etape5.packopen" :key="indexpackopen">
                <span v-if="packopen.field_type_de_promotion !== null && packopen.field_type_de_promotion == 1" class="c-orange">
                  Edition Spéciale {{ packopen.field_titre_de_la_promotion }}
                </span>
              </template>
            </template>
            <template v-if="data_etape5 && data_etape5.packopen && Object.keys(data_etape5.packopen).length > 0 && parcours.etape >= 4">
              <template v-for="(packopen, indexpackopen) in data_etape5.packopen" :key="indexpackopen">
                <span v-if="packopen.field_type_de_promotion !== null && packopen.field_type_de_promotion == 2" class="c-orange">
                  Edition Limitée {{ packopen.field_titre_de_la_promotion }}
                </span>
              </template>
            </template>
            <template v-if="data_etape5 && data_etape5.forfaitselection && parcours.etape >= 4">
              <template v-for="(forfait, indexforfait) in data_etape5.forfaitselection" :key="indexforfait">
                <span class="c-orange">{{ forfait.field_internet }}Go</span>
              </template>
            </template>
          </p>
        </div>



        <div class="dflex items-center flex-1">
          <div v-if="data_etape5 && data_etape5.packopen && Object.keys(data_etape5.packopen).length > 0 && parcours.etape >= 4" class="dflex items-baseline flex-wrap gap-5 lg:ml-auto">
            <span v-if="(price + totalAdditionnelPrice) > 0" class="c-orange text-2xl lg:text-34 leading-28 lg:leading-40 text-bold">{{ (price + totalAdditionnelPrice).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>
            <span v-else class="c-orange text-2xl lg:text-34 leading-28 lg:leading-40 text-bold">Offert<sup>(4)</sup></span>
            <span v-if="price2" class="line-through c-greyLight text-bold text-sm lg:text-base leading-20 lg:leading-22">
                {{ (price2 + totalAdditionnelPrice2).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€
            </span>
            <div class="infoToolTip posLeft">
              <button @click.prevent="loadDialog('none')" class="pointer dflex" type="button" aria-expanded="false" aria-controls="tooltipPanier1">
                <span class="w-20 h-20 c-greyLight"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17"><path fill="currentColor" fill-rule="evenodd" d="M10.7702 13.4945H6.6838v-.4675l.096-.003c.2826-.0091.4925-.0893.6242-.2386.0468-.0539.1264-.2379.1264-.8563V7.8028c0-.5883-.0822-.81-.151-.8925-.0973-.116-.3-.1843-.6024-.2026l-.0932-.0057v-.4722h3.1783v5.6993c0 .5887.1536.8103.2223.8925.097.116.2848.1842.5926.2025l.0932.0055v.4649ZM8.5 2.5975c.7523 0 1.3621.6098 1.3621 1.362 0 .7524-.6098 1.3622-1.3621 1.3622-.7523 0-1.3621-.6098-1.3621-1.3621 0-.7523.6098-1.3621 1.3621-1.3621Zm0-1.8163C4.237.7813.7812 4.2371.7812 8.5S4.2371 16.2188 8.5 16.2188s7.7188-3.4559 7.7188-7.7188c0-4.263-3.4559-7.7188-7.7188-7.7188Z" clip-rule="evenodd"></path></svg></span>
              </button>
            </div>
            <p v-if="price2" class="text-sm c-greyLight font-medium lg:basis-full">
                Pendant
                  {{ duree }} mois<sup>(5)</sup> puis
                  {{ (price2 + totalAdditionnelPrice2).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€&nbsp;/mois
            </p>
            <p v-else class="text-sm c-greyLight font-medium lg:basis-full">
                Dont remise Open de
                <span>{{ packopen?.field_remise.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€&nbsp;/mois</span>
            </p>
          </div>
          <div v-if="parcours.etape == 1 && parcours.mobile == 0" class="ml-auto lg:ml-0 lg:order-first">
            <button @click="taggage('recap_configurateur_open', 'details', 'https://caraibe.orange.fr/packs-open-forfaits-mobile-et-internet', { tealium_event: 'select_content' })" id="poRecapToggleD" class="poRecapToggleD text-bold pointer dflex items-center c-grey11 relative lg:top-5" :class="{ 'screeb-detail': parcours.etape == 5 }" type="button" aria-controls="poRecap" aria-expanded="false">
              <span class="text-sm lg:text-base leading-20 lg:leading-22">Détails</span>
              <span id="poRecapToggleSvg" class="svg-18 w-18 dflex rotate-90" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path fill="currentColor" d="M7.482 14.344 12.937 9 7.482 3.656 5.924 5.182 9.82 9l-3.897 3.816 1.558 1.528Z"></path></svg></span>
            </button>
          </div>
          <div v-else class="ml-auto lg:ml-0 lg:order-first">
            <button @click="taggage('recap_configurateur_open', 'details', 'https://caraibe.orange.fr/packs-open-forfaits-mobile-et-internet', { tealium_event: 'select_content' })" id="poRecapToggle" class="poRecapToggle text-bold pointer dflex items-center relative lg:top-5" :class="{ 'screeb-detail': parcours.etape == 5 }" type="button" aria-controls="poRecap" aria-expanded="false">
              <span class="text-sm lg:text-base leading-20 lg:leading-22">Détails</span>
              <span id="poRecapToggleSvg" class="svg-18 w-18 dflex c-orange rotate-90" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path fill="currentColor" d="M7.482 14.344 12.937 9 7.482 3.656 5.924 5.182 9.82 9l-3.897 3.816 1.558 1.528Z"></path></svg></span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="data_etape5.selmobileselected && Object.keys(data_etape5.selmobileselected).length > 0" class="bg-grey14 py-14">
      <template v-for="(mobile, indexmobile) in data_etape5.selmobileselected" :key="indexmobile">
        <div class="container">
          <div class="text-bold text-lg lg:dflex gap-x-5 items-center">
            Votre nouveau mobile <br class="lg:hidden"><span class="hidden lg:inline"> :</span> <span class="text-base c-greyLight">{{ mobile.field_marque}}</span> {{ mobile.title }}
            <div v-if="forfaitSelection" class="inflex items-baseline gap-5 lg:ml-auto">
              <span class="c-orange text-xl leading-24 text-bold">{{ Number(mobile[typePrice[forfaitSelection.field_niveau_prix_mobile]]).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>
              <div class="infoToolTip posLeft">
                <button class="pointer dflex" type="button" aria-expanded="false" aria-controls="tooltipPanierMobile1">
                  <span class="w-16 h-16 c-greyLight"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17"><path fill="currentColor" fill-rule="evenodd" d="M10.7702 13.4945H6.6838v-.4675l.096-.003c.2826-.0091.4925-.0893.6242-.2386.0468-.0539.1264-.2379.1264-.8563V7.8028c0-.5883-.0822-.81-.151-.8925-.0973-.116-.3-.1843-.6024-.2026l-.0932-.0057v-.4722h3.1783v5.6993c0 .5887.1536.8103.2223.8925.097.116.2848.1842.5926.2025l.0932.0055v.4649ZM8.5 2.5975c.7523 0 1.3621.6098 1.3621 1.362 0 .7524-.6098 1.3622-1.3621 1.3622-.7523 0-1.3621-.6098-1.3621-1.3621 0-.7523.6098-1.3621 1.3621-1.3621Zm0-1.8163C4.237.7813.7812 4.2371.7812 8.5S4.2371 16.2188 8.5 16.2188s7.7188-3.4559 7.7188-7.7188c0-4.263-3.4559-7.7188-7.7188-7.7188Z" clip-rule="evenodd"></path></svg></span>
                </button>
                <div id="tooltipPanierMobile1" class="infoToolTip__content richContent text-base text-regular c-black">
                  <template v-if="data_etape5 && data_etape5.forfaitselection">
                    <template v-for="(forfait, indexforfait) in data_etape5.forfaitselection" :key="indexforfait">
                      <p>Prix du mobile valable avec le forfait {{ forfait.field_internet }}Go configuré dans votre Pack Open, avec engagement 12 mois.</p>
                    </template>
                  </template>
                </div>
              </div>
            </div>
            <div v-if="!forfaitSelection && parcours.etape > 1" class="inflex items-baseline gap-5 lg:ml-auto">
              <template v-for="(forfait, indexforfait) in data_etape5.selforfaitselected" :key="indexforfait">
                <span class="c-orange text-xl leading-24 text-bold">{{ Number(mobile[typePrice[forfait.field_niveau_prix_mobile]]).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>
                <div class="infoToolTip posLeft">
                  <button class="pointer dflex" type="button" aria-expanded="false" aria-controls="tooltipPanierMobile1">
                    <span class="w-16 h-16 c-greyLight"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17"><path fill="currentColor" fill-rule="evenodd" d="M10.7702 13.4945H6.6838v-.4675l.096-.003c.2826-.0091.4925-.0893.6242-.2386.0468-.0539.1264-.2379.1264-.8563V7.8028c0-.5883-.0822-.81-.151-.8925-.0973-.116-.3-.1843-.6024-.2026l-.0932-.0057v-.4722h3.1783v5.6993c0 .5887.1536.8103.2223.8925.097.116.2848.1842.5926.2025l.0932.0055v.4649ZM8.5 2.5975c.7523 0 1.3621.6098 1.3621 1.362 0 .7524-.6098 1.3622-1.3621 1.3622-.7523 0-1.3621-.6098-1.3621-1.3621 0-.7523.6098-1.3621 1.3621-1.3621Zm0-1.8163C4.237.7813.7812 4.2371.7812 8.5S4.2371 16.2188 8.5 16.2188s7.7188-3.4559 7.7188-7.7188c0-4.263-3.4559-7.7188-7.7188-7.7188Z" clip-rule="evenodd"></path></svg></span>
                  </button>
                  <div id="tooltipPanierMobile1" class="infoToolTip__content richContent text-base text-regular c-black">
                    <p>Prix du mobile valable avec le forfait {{ forfait.field_internet }}Go configuré dans votre Pack Open, avec engagement 12 mois.</p>
                  </div>
                </div>
              </template>
            </div>
            <div v-if="!forfaitSelection && (!data_etape5.selforfaitselected || data_etape5.selforfaitselected.length === 0)" class="inflex items-baseline gap-5 lg:ml-auto">
              <span class="c-orange text-xl leading-24 text-bold">{{ Number(mobile.field_prix_elite).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div v-if="data_etape5.selforfaitselected && Object.keys(data_etape5.selforfaitselected).length > 0 && parcours.etape >= 2" class="container">
      <div class="lg:grid lg:gap-60 lg:mt-30">
        <div class="col-forfaits col-span-6 py-24 lg:py-0 border-b1-grey14 lg:border-b-0 relative">
          <table v-if="forfaitSelection && forfaitSelection.field_remise_en_du_forfait && forfaitSelection.field_remise_en_du_forfait > 0" class="w-full border-b1-grey14 mb-10 lg:mb-25">
            <caption class="text-bold text-lg leading-24">Forfait(s)</caption>
            <tbody>
              <tr>
                <td v-if="packopen.field_type_de_promotion" class="text-bold py-10 pb-24 align-middle">
                  Ed. {{ packopen.field_titre_de_la_promotion }} {{ forfaitSelection.field_internet }}Go
                </td>
                <td v-else class="text-bold py-10 pb-24 align-middle">
                  {{ packopen.field_titre_de_la_promotion }} {{ forfaitSelection.field_internet }}Go
                </td>
                <td class="text-end py-10 pb-24 align-middle">
                  <span class="line-through c-greyLight text-bold mr-10">{{ forfaitSelection?.field_prix_forfait.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>
                  <span class="text-sm text-bold"><span class="c-orange text-xl">{{ prixRemisePercent.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois</span>
                </td>
              </tr>
            </tbody>
          </table>
          <table v-else class="w-full border-b1-grey14 mb-10">
            <caption class="text-bold">Forfait(s)</caption>
            <tbody>
              <tr>
                <td v-if="forfaitSelection" class="text-bold py-10 pb-24 align-middle">
                  <span v-if="packopen?.field_type_de_promotion">
                    <span v-if="packopen.field_type_de_promotion == 1" class="c-orange">Ed. {{ packopen.field_titre_de_la_promotion.value }} <span class="c-orange">{{ forfaitSelection.field_internet }}Go</span></span>
                    <span v-if="packopen.field_type_de_promotion == 2" class="c-orange">Ed. Limitée <span class="c-orange">{{ forfaitSelection.field_internet }}Go</span></span>
                  </span>
                  <span v-else>
                    {{ forfaitSelection?.field_internet }}Go
                  </span>
                </td>
                <td v-if="!forfaitSelection" class="text-bold py-10 pb-24 align-middle">
                  <template v-for="(forfait, indexforfait) in data_etape5.selforfaitselected" :key="indexforfait">
                    <span>{{ forfait.field_internet }}Go</span>
                  </template>
                </td>
                <td v-if="forfaitSelection" class="text-end py-10 pb-24 align-middle">
                  <span class="text-sm text-bold"><span class="c-orange text-xl">{{ forfaitSelection?.field_prix_forfait.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois</span>
                </td>
                <td v-if="!forfaitSelection" class="text-end py-10 pb-24 align-middle">
                  <template v-for="(forfait, indexforfait) in data_etape5.selforfaitselected" :key="indexforfait">
                    <span class="text-sm text-bold"><span class="c-orange text-xl">{{ Number(forfait.field_prix_forfait).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois</span>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>


          <table v-if="data_etape5 && data_etape5.forfaitadditionnelsforme && Object.keys(data_etape5.forfaitadditionnelsforme).length > 0" class="w-full mb-20 lg:mb-25">
            <caption class="mb-10">
              <span class="dflex dflex-col lg:dflex-row gap-5">
                <span>Forfaits mobiles</span>
                <span class="dflex gap-5">
                  <span class="text-bold c-orange">Additionnel(s) pour vous</span>
                  <div v-if="data_etape5 && data_etape5.packopen && Object.keys(data_etape5.packopen).length > 0" class="infoToolTip posLeft">
                    <button @click.prevent="loadDialog('forme')" class="pointer dflex" type="button" aria-expanded="false" aria-controls="tooltipPanier2">
                      <span class="w-20 h-20 c-greyLight"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17"><path fill="currentColor" fill-rule="evenodd" d="M10.7702 13.4945H6.6838v-.4675l.096-.003c.2826-.0091.4925-.0893.6242-.2386.0468-.0539.1264-.2379.1264-.8563V7.8028c0-.5883-.0822-.81-.151-.8925-.0973-.116-.3-.1843-.6024-.2026l-.0932-.0057v-.4722h3.1783v5.6993c0 .5887.1536.8103.2223.8925.097.116.2848.1842.5926.2025l.0932.0055v.4649ZM8.5 2.5975c.7523 0 1.3621.6098 1.3621 1.362 0 .7524-.6098 1.3622-1.3621 1.3622-.7523 0-1.3621-.6098-1.3621-1.3621 0-.7523.6098-1.3621 1.3621-1.3621Zm0-1.8163C4.237.7813.7812 4.2371.7812 8.5S4.2371 16.2188 8.5 16.2188s7.7188-3.4559 7.7188-7.7188c0-4.263-3.4559-7.7188-7.7188-7.7188Z" clip-rule="evenodd"></path></svg></span>
                    </button>
                  </div>
                </span>
              </span>
            </caption>
            <tbody>
              <tr v-for="(forfaitadditionnelforme, indexforfaitadditionnelforme) in data_etape5.forfaitadditionnelsforme" :key="indexforfaitadditionnelforme">
                <td class="text-bold py-5 align-middle">
                  <template v-if="forfaitadditionnelforme?.field_type_de_promotion">
                    <template v-if="forfaitadditionnelforme.field_type_de_promotion == 1">
                      Ed. {{ forfaitadditionnelforme?.field_titre_de_la_promotion }} {{ forfaitadditionnelforme?.field_internet }}Go <span class="c-orange text-sm leading-20" v-if="forfaitadditionnelforme.multiple > 1">x{{ forfaitadditionnelforme.multiple }}</span>
                    </template>
                    <template v-if="forfaitadditionnelforme.field_type_de_promotion == 2">
                      Ed. Limitée {{ forfaitadditionnelforme?.field_internet }}Go <span class="c-orange text-sm leading-20" v-if="forfaitadditionnelforme.multiple > 1">x{{ forfaitadditionnelforme.multiple }}</span>
                    </template>
                  </template>
                  <template v-else>
                    {{ forfaitadditionnelforme?.field_internet }}Go <span class="c-orange text-sm leading-20" v-if="forfaitadditionnelforme.multiple > 1">x{{ forfaitadditionnelforme.multiple }}</span>
                  </template>
                </td>
                <td class="text-end py-5 align-middle">
                  <span class="text-sm text-bold">
                    <span class="line-through c-greyLight text-bold mr-10">{{ (forfaitadditionnelforme.field_prix_forfait * forfaitadditionnelforme.multiple).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>
                    <span v-if="getAdditionnelPromoprice(forfaitadditionnelforme) <= 0" class="c-orange text-xl">Offert<sup>(4)</sup></span>
                    <span v-else><span class="c-orange text-xl">{{ getAdditionnelPromoprice(forfaitadditionnelforme).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois</span>
                  </span>
                </td>
              </tr>
              <tr v-if="totalRemiseAdditionnelForme && totalRemiseAdditionnelForme > 0">
                <td class="py-5 align-middle">Remise Open Multilignes</td>
                <td class="py-5 text-end align-middle">
                  <span class="text-sm text-bold"><span class="c-orange text-xl">-{{ totalRemiseAdditionnelForme.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois</span>
                </td>
              </tr>
            </tbody>
          </table>

          <table v-if="data_etape5 && data_etape5.forfaitadditionnelsforyou && Object.keys(data_etape5.forfaitadditionnelsforyou).length > 0" class="w-full mb-20 lg:mb-25">
            <caption class="mb-10">
              <span class="dflex dflex-col lg:dflex-row gap-5">
                <span>Forfaits mobiles</span>
                <span class="dflex gap-5">
                  <span class="text-bold c-orange">Additionnel(s) pour un tiers</span>
                  <div v-if="data_etape5 && data_etape5.packopen && Object.keys(data_etape5.packopen).length > 0" class="infoToolTip posLeft">
                    <button @click.prevent="loadDialog('foryou')" class="pointer dflex" type="button" aria-expanded="false" aria-controls="tooltipPanier2">
                      <span class="w-20 h-20 c-greyLight"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17"><path fill="currentColor" fill-rule="evenodd" d="M10.7702 13.4945H6.6838v-.4675l.096-.003c.2826-.0091.4925-.0893.6242-.2386.0468-.0539.1264-.2379.1264-.8563V7.8028c0-.5883-.0822-.81-.151-.8925-.0973-.116-.3-.1843-.6024-.2026l-.0932-.0057v-.4722h3.1783v5.6993c0 .5887.1536.8103.2223.8925.097.116.2848.1842.5926.2025l.0932.0055v.4649ZM8.5 2.5975c.7523 0 1.3621.6098 1.3621 1.362 0 .7524-.6098 1.3622-1.3621 1.3622-.7523 0-1.3621-.6098-1.3621-1.3621 0-.7523.6098-1.3621 1.3621-1.3621Zm0-1.8163C4.237.7813.7812 4.2371.7812 8.5S4.2371 16.2188 8.5 16.2188s7.7188-3.4559 7.7188-7.7188c0-4.263-3.4559-7.7188-7.7188-7.7188Z" clip-rule="evenodd"></path></svg></span>
                    </button>
                  </div>
                </span>
              </span>
            </caption>
            <tbody>
              <tr v-for="(forfaitadditionnelforyou, indexforfaitadditionnelforyou) in data_etape5.forfaitadditionnelsforyou" :key="indexforfaitadditionnelforme">
                <td class="text-bold py-5 align-middle">
                  <template v-if="forfaitadditionnelforyou?.field_type_de_promotion">
                    <template v-if="forfaitadditionnelforyou.field_type_de_promotion == 1">
                      Ed. {{ forfaitadditionnelforyou?.field_titre_de_la_promotion }} {{ forfaitadditionnelforyou?.field_internet }}Go <span class="c-orange text-sm leading-20" v-if="forfaitadditionnelforyou.multiple > 1">x{{ forfaitadditionnelforyou.multiple }}</span>
                    </template>
                    <template v-if="forfaitadditionnelforyou.field_type_de_promotion == 2">
                      Ed. Limitée {{ forfaitadditionnelforyou?.field_internet }}Go <span class="c-orange text-sm leading-20" v-if="forfaitadditionnelforyou.multiple > 1">x{{ forfaitadditionnelforyou.multiple }}</span>
                    </template>
                  </template>
                  <template v-else>
                    {{ forfaitadditionnelforyou?.field_internet }}Go <span class="c-orange text-sm leading-20" v-if="forfaitadditionnelforyou.multiple > 1">x{{ forfaitadditionnelforyou.multiple }}</span>
                  </template>
                </td>
                <td class="text-end py-5 align-middle">
                  <span class="text-sm text-bold">
                    <span class="line-through c-greyLight text-bold mr-10">{{ (forfaitadditionnelforyou.field_prix_forfait * forfaitadditionnelforyou.multiple).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>
                    <span v-if="getAdditionnelPromoprice(forfaitadditionnelforyou) <= 0" class="c-orange text-xl">Offert<sup>(4)</sup></span>
                    <span v-else><span class="c-orange text-xl">{{ getAdditionnelPromoprice(forfaitadditionnelforyou).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois</span>
                  </span>
                </td>
              </tr>
              <tr v-if="totalRemiseAdditionnelForyou && totalRemiseAdditionnelForyou > 0">
                <td class="py-5 align-middle">Remise Open Multilignes</td>
                <td class="py-5 text-end align-middle">
                  <span class="text-sm text-bold"><span class="c-orange text-xl">-{{ totalRemiseAdditionnelForyou.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="data_etape5 && data_etape5.packopen && Object.keys(data_etape5.packopen).length > 0 && parcours.etape >= 4" class="col-offreInternet col-span-6 py-24 lg:py-0 border-b1-grey14 lg:border-b-0">
          <table class="w-full lg:border-b1-grey14">
            <caption class="text-bold text-lg leading-24">Offre Internet</caption>
            <tbody>
              <tr>
                <td class="text-bold py-10 pb-24 align-middle">
                  <template v-if="data_etape5 && data_etape5.serviceselection">
                    <template v-for="(service, indexservice) in data_etape5.serviceselection" :key="indexservice">{{ service.field_type_de_connexion[0] + ' ' + service.field_type_de_forfait[0] }}</template>
                  </template>
                </td>
                <td v-if="forfaitSelection && forfaitSelection.field_remise_en_du_forfait && forfaitSelection.field_remise_en_du_forfait > 0" class="text-end py-10 pb-24 align-middle">
                  <template v-if="serviceSelection && serviceSelection.field_remise_en_pourcentage && serviceSelection.field_remise_en_pourcentage > 0">
                    <span class="line-through c-greyLight text-bold mr-10">{{ serviceSelection?.field_prix_service.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>
                    <span class="text-sm text-bold"><span class="c-orange text-xl">{{ prixServiceRemisePercent.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois</span>
                  </template>
                  <template v-else>
                    <span class="text-sm text-bold"><span class="c-orange text-xl">{{ serviceSelection?.field_prix_service.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois</span>
                  </template>
                </td>
                <td v-else class="text-end py-10 pb-24 align-middle">
                  <template v-if="serviceSelection && serviceSelection.field_remise_en_pourcentage && serviceSelection.field_remise_en_pourcentage > 0">
                    <span class="line-through c-greyLight text-bold">{{ serviceSelection?.field_prix_service.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€ </span>
                    <span class="text-sm text-bold"><span class="c-orange text-xl">{{ prixServiceRemisePercent.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois</span>
                  </template>
                  <template v-else>
                    <span class="text-sm text-bold"><span class="c-orange text-xl">{{ serviceSelection?.field_prix_service.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois</span>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="hidden lg:block dflex dflex-col max-w-450">
            <p class="py-34 lg:py-24">{{ data_etape0.field_etape5_sous_titre }}</p>
            <a @click="taggage('details_configurateur_open', 'prendre_rdv_pack_open', 'https://espace-client.orange.fr/rdv/creation', { tealium_event: 'select_content' });taggageRecap('', '', '', globalStore.tag)" class="btn btn--md btn--fill-light w-345 lg:w-280" target="_blank" :href="data_etape0.field_etape5_cta[0].url" :title="data_etape0.field_etape5_cta[0].title">{{ data_etape0.field_etape5_cta[0].title }}</a>
          </div>
        </div>
      </div>
    </div>

    <div class="containerl lg:hidden">
      <div class="dflex dflex-col items-center">
        <p class="text-center font-medium py-34">{{ data_etape0.field_etape5_sous_titre }}</p>
        <a @click="taggage('details_configurateur_open', 'prendre_rdv_pack_open', 'https://espace-client.orange.fr/rdv/creation', { tealium_event: 'select_content' });taggageRecap('', '', '', globalStore.tag)" class="btn btn--md btn--fill-light w-345 lg:w-280" target="_blank" :href="data_etape0.field_etape5_cta[0].url" :title="data_etape0.field_etape5_cta[0].title">{{ data_etape0.field_etape5_cta[0].title }}</a>
      </div>
    </div>
  </section>

  <dialog class="jsModale2 jsModale--light" data-modale-id="1">


    <header class="font-bold py-15 px-20 pr-30">
      <p class="text-xl lg:text-22 leading-24 lg:leading-26">
        Le détail de votre offre Pack Open
        <template v-if="data_etape5 && data_etape5.packopen && Object.keys(data_etape5.packopen).length > 0">
          <template v-for="(packopen, indexpackopen) in data_etape5.packopen" :key="indexpackopen">
            <span v-if="packopen.field_type_de_promotion !== null && packopen.field_type_de_promotion == 1" class="c-orange">
              Edition Spéciale {{ packopen.field_titre_de_la_promotion }}
            </span>
          </template>
        </template>
        <template v-if="data_etape5 && data_etape5.packopen && Object.keys(data_etape5.packopen).length > 0">
          <template v-for="(packopen, indexpackopen) in data_etape5.packopen" :key="indexpackopen">
            <span v-if="packopen.field_type_de_promotion !== null && packopen.field_type_de_promotion == 2" class="c-orange">
              Edition Limitée {{ packopen.field_titre_de_la_promotion }}
            </span>
          </template>
        <template v-if="data_etape5 && data_etape5.forfaitselection">
          <template v-for="(forfait, indexforfait) in data_etape5.forfaitselection" :key="indexforfait">
            <span v-if="forfait.field_appels > 0" class="c-orange">{{ forfait.field_appels }}h </span>
            <span v-if="forfait.field_internet > 0" class="c-orange">{{ forfait.field_internet }}Go </span>
          </template>
        </template>
        </template>
         <template v-if="data_etape5 && data_etape5.serviceselection">
          <template v-for="(service, indexservice) in data_etape5.serviceselection" :key="indexservice">{{ service.field_type_de_forfait[0] + ' ' }}{{ service.field_type_de_connexion[0] + ' ' }} </template>
        </template>

        <template v-if="(price + totalAdditionnelPrice) > 0">
          à <span class="c-orange">{{ (price + totalAdditionnelPrice).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span> <span class="lg:text-sm lg:leading-20">/mois</span></br>
        </template>
        <template v-else>
          <span class="c-orange">Offert</span></br>
        </template>

        <span v-if="price2" class="font-regular mt-10 text-sm lg:text-base leading-20 lg:leading-22 block">
          Pendant
          {{ duree }} mois puis
          {{ (price2 + totalAdditionnelPrice2).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€&nbsp;/mois
        </span>
      </p>

      <button class="jsModaleClose absolute top-0 right-0 w-40 h-40 pointer z-10" type="button" title="Fermer la modale"><span class="sr-only">Fermer la modale</span><span class="c-black dflex-center" aria-hidden="true"><img src="@/assets/images/ico-cross.svg" alt="" /></span></button>
    </header>


    <section v-if="totalRemise > 0" class="p-20 relative">

      <div>
        <p class="font-bold leading-22 mb-35">Votre tarif comprend les remises suivantes :</p>
        <ul class="mb-40">
          <template v-if="data_etape5 && data_etape5.packopen && Object.keys(data_etape5.packopen).length > 0">
            <template v-for="(packopen, indexpackopen) in data_etape5.packopen" :key="indexpackopen">
              <li v-if="premiereRemise > 0" class="mb-30">
                <p class="font-bold mb-10">Remise Pack Open <sup>(1)</sup> :<br class="lg:hidden"> <span class="c-orange text-xl">-{{ packopen.field_remise.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois <span class="font-regular">à vie</span></p>
                <div class="border-l8-blue bg-grey15 p-15 font-bold mb-20 max-w-400">Soit un avantage de {{ premiereRemise.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€/an <span class="font-regular">à vie</span></div>
              </li>
            </template>
          </template>
          <template v-if="data_etape5 && data_etape5.packopen && Object.keys(data_etape5.packopen).length > 0">
            <template v-for="(packopen, indexpackopen) in data_etape5.packopen" :key="indexpackopen">
              <li v-if="deuxiemeRemise > 0" class="mb-40">
                <p class="font-bold mb-10">Remise nouveau client Open {{ packopen.field_libelle_2eme_remise }} <sup>(2)</sup> :<br class="lg:hidden"> <span class="c-orange text-xl">-{{ packopen.field_deuxieme_remise.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois <span class="font-regular">pendant {{ packopen.field_duree_deuxieme_remise }} mois</span></p>
                <div class="border-l8-blue bg-grey15 p-15 font-bold mb-20 max-w-400">Soit un avantage de {{ deuxiemeRemise.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€ <span class="font-regular">pendant vos {{ packopen.field_duree_deuxieme_remise }} premiers mois</span></div>
              </li>
            </template>
          </template>
          <li v-if="totalRemise > 0">
            <p class="font-bold">Soit <span class="c-orange text-xl">{{ totalRemise.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span> de remises cumulées<br class="lg:hidden"> <span class="font-regular">sur votre première année</span></p>
          </li>
        </ul>

        <div v-if="totalRemise > 0" class="bg-blue4 p-20 dflex items-start gap mb-40">
          <span class="dflex c-blue2 w-26 shrink-0"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 45 45"><path fill="currentColor" fill-rule="evenodd" d="M28.833 36.432h-11.4v-1.304l.269-.008c.788-.026 1.373-.25 1.74-.666.131-.15.353-.664.353-2.389v-11.51c0-1.64-.229-2.26-.42-2.49-.272-.323-.838-.514-1.681-.565l-.26-.015v-1.318H26.3v15.898c0 1.643.428 2.26.62 2.49.27.324.794.514 1.653.565l.26.015v1.297ZM22.5 6.035a3.8 3.8 0 1 1 0 7.6 3.8 3.8 0 0 1 0-7.6Zm0-5.066C10.609.969.969 10.609.969 22.5c0 11.891 9.64 21.531 21.531 21.531 11.891 0 21.531-9.64 21.531-21.531C44.031 10.609 34.391.969 22.5.969Z" clip-rule="evenodd"></path></svg></span>
          <p class="leading-22">Si vous passez commande maintenant, vous payerez :<br>
            <span class="font-bold">{{ (price + totalAdditionnelPrice).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€/mois</span>
            <template v-if="price2 > 0">
              pendant vos {{ duree }} premiers mois puis <span class="font-bold">{{ (price2 + totalAdditionnelPrice2).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} €&nbsp;/mois</span>
            </template>
          </p>
        </div>
        <div v-if="totalRemise > 0" class="pb-40 mb-40 border-b1-greyLight">
          <ol>
            <template v-if="data_etape5 && data_etape5.packopen && Object.keys(data_etape5.packopen).length > 0">
              <template v-for="(packopen, indexpackopen) in data_etape5.packopen" :key="indexpackopen">
                <li v-if="cleanedMention1 !=''" class="mb-20">
                  <p class="text-sm"><sup class="font-bold">(1)</sup> <span class="font-bold">Remise Packs Open :</span> <span v-html="cleanedMention1"></span></p>
                </li>
                <li v-if="cleanedMention2 !=''" >
                  <p class="text-sm"><sup class="font-bold">(2)</sup> <span class="font-bold">Remise {{ packopen.field_libelle_2eme_remise  }} :</span> <span v-html="cleanedMention2"></span></p>
                </li>
              </template>
            </template>
          </ol>
        </div>
      </div>

      <div v-if="data_etape5 && (data_etape5.forfaitadditionnelsforme && Object.keys(data_etape5.forfaitadditionnelsforme).length > 0) || (data_etape5.forfaitadditionnelsforyou && Object.keys(data_etape5.forfaitadditionnelsforyou).length > 0)">
        <p class="font-bold leading-22 mb-35">Grace à Open, voici les remises sur votre/vos forfait(s) Additionnel(s)<sup>(3)</sup> :</p>

        <ul class="mb-40">
          <li v-if="data_etape5 && (data_etape5.forfaitadditionnelsforme && Object.keys(data_etape5.forfaitadditionnelsforme).length > 0)" class="mb-30" id="forme">
            <p class="mb-20">Forfait(s) mobile(s) <span class="c-orange font-bold">Additionnel(s) pour vous</span></p>
            <table class="w-full max-w-400 mb-25">
              <tbody>
                <tr v-for="(forfaitadditionnelforme, indexforfaitadditionnelforme) in data_etape5.forfaitadditionnelsforme" :key="indexforfaitadditionnelforme">
                  <td class="font-bold leading-22 h-40 align-middle">
                    <template v-if="forfaitadditionnelforme?.field_type_de_promotion">
                      <template v-if="forfaitadditionnelforme.field_type_de_promotion == 1">
                        Forfait Ed. {{ forfaitadditionnelforme?.field_titre_de_la_promotion }} {{ forfaitadditionnelforme?.field_internet }}Go <span class="c-orange text-sm leading-20" v-if="forfaitadditionnelforme.multiple > 1">x{{ forfaitadditionnelforme.multiple }}</span>
                      </template>
                      <template v-if="forfaitadditionnelforme.field_type_de_promotion == 2">
                        Forfait Ed. Limitée {{ forfaitadditionnelforme?.field_internet }}Go <span class="c-orange text-sm leading-20" v-if="forfaitadditionnelforme.multiple > 1">x{{ forfaitadditionnelforme.multiple }}</span>
                      </template>
                    </template>
                    <template v-else>
                      Forfait {{ forfaitadditionnelforme?.field_internet }}Go <span class="c-orange text-sm leading-20" v-if="forfaitadditionnelforme.multiple > 1">x{{ forfaitadditionnelforme.multiple }}</span>
                    </template>
                  </td>
                  <td class="font-bold h-40 align-middle">
                    <span class="font-bold h-40 align-middle">
                      <span class="c-orange text-xl leading-24">-{{ (forfaitadditionnelforme.field_remise_forfait_additionnel * forfaitadditionnelforme.multiple).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span><span class="text-sm">&nbsp;/mois</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="border-l8-blue bg-grey15 p-15 font-bold mb-20 max-w-400">Soit une remise cumulée de {{ (totalRemiseAdditionnelForme * 12).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€ /an <span class="font-regular">sur vos forfaits</span></div>
          </li>

          <li v-if="data_etape5 && (data_etape5.forfaitadditionnelsforyou && Object.keys(data_etape5.forfaitadditionnelsforyou).length > 0)" class="mb-30" id="foryou">
            <p class="mb-20">Forfait(s) mobile(s) <span class="c-orange font-bold">Additionnel(s) pour un tiers</span></p>
            <table class="w-full max-w-400 mb-25">
              <tbody>
                <tr v-for="(forfaitadditionnelforyou, indexforfaitadditionnelforyou) in data_etape5.forfaitadditionnelsforyou" :key="indexforfaitadditionnelforyou">
                  <td class="font-bold leading-22 h-40 align-middle">
                    <template v-if="forfaitadditionnelforyou?.field_type_de_promotion">
                      <template v-if="forfaitadditionnelforyou.field_type_de_promotion == 1">
                        Forfait Ed. {{ forfaitadditionnelforyou?.field_titre_de_la_promotion }} {{ forfaitadditionnelforyou?.field_internet }}Go <span class="c-orange text-sm leading-20" v-if="forfaitadditionnelforyou.multiple > 1">x{{ forfaitadditionnelforyou.multiple }}</span>
                      </template>
                      <template v-if="forfaitadditionnelforyou.field_type_de_promotion == 2">
                        Forfaot Ed. Limitée {{ forfaitadditionnelforyou?.field_internet }}Go <span class="c-orange text-sm leading-20" v-if="forfaitadditionnelforyou.multiple > 1">x{{ forfaitadditionnelforyou.multiple }}</span>
                      </template>
                    </template>
                    <template v-else>
                      {{ forfaitadditionnelforyou?.field_internet }}Go <span class="c-orange text-sm leading-20" v-if="forfaitadditionnelforyou.multiple > 1">x{{ forfaitadditionnelforyou.multiple }}</span>
                    </template>
                  </td>
                  <td class="font-bold h-40 align-middle">
                    <span class="font-bold h-40 align-middle">
                      <span class="c-orange text-xl leading-24">-{{ (forfaitadditionnelforyou.field_remise_forfait_additionnel * forfaitadditionnelforyou.multiple).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span><span class="text-sm">&nbsp;/mois</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="border-l8-blue bg-grey15 p-15 font-bold mb-20 max-w-400">Soit une remise cumulée de {{ (totalRemiseAdditionnelForyou * 12).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€ /an <span class="font-regular">sur vos forfaits</span></div>
          </li>
        </ul>

        <div class="pb-40 mb-40 border-b1-greyLight">
          <ol>
            <li>
              <p class="text-sm"><sup class="font-bold">(3)</sup> <span class="font-bold">Remise :</span> -5€&nbsp;/mois valable pour toute souscription ou migration vers un forfait 2h 2Go, 2h20Go ou illimité 30Go ou -10€&nbsp;/mois valable pour toute souscription ou migration vers un forfait illimité, 150Go, 200Go, ou 250Go et Édition Spéciale Guyane 100Go. La remise Open Multilignes est appliquée dès la première facture. L’activation de la remise Open multilignes est soumise aux conditions de compatibilité et nécessite que les conditions d’attribution soient remplies. L’accord préalable du titulaire du pack Open est obligatoire pour que la remise Open multilignes soit activée. Cette remise pourra être supprimée par le titulaire de l’offre Open ou mobile depuis son Espace Client. En cas de résiliation du pack Open, la remise Open multilignes sera supprimée sur l’ensemble des lignes bénéficiaires.</p>
            </li>
          </ol>
        </div>
      </div>

      <div v-if="data_etape5.selmobileselected && Object.keys(data_etape5.selmobileselected).length > 0" class="pb-40 mb-40 border-b1-greyLight">
        <template v-for="(mobile, indexmobile) in data_etape5.selmobileselected" :key="indexmobile">
          <p class="font-bold leading-22 mb-35">Votre mobile</p>
          <p class="text-sm text-bold leading-20 c-grey11">{{ mobile.field_marque}}</p>
          <p class="text-bold leading-22 mb-10">{{ mobile.title }}</p>
          <p class="font-bold mb-10"><span class="c-orange text-xl leading-20">{{ Number(mobile[typePrice[forfaitSelection.field_niveau_prix_mobile]]).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span></p>
          <p class="text-sm leading-20">Voir modalités de paiement en boutique</p>
        </template>
      </div>

    </section>

    <footer class="py-15 px-20">
      <p class="text-center mb-25">Prenez rendez-vous en boutique, nos équipes vous assisteront pour faire les bons choix !</p>
      <div class="dflex justify-center">
        <a @click.prevent="taggage('details_configurateur_open', 'prendre_rdv_pack_open', 'https://espace-client.orange.fr/rdv/creation', { tealium_event: 'select_content' })" class="btn btn--md btn--fill-dark" href="https://espace-client.orange.fr/rdv/creation" target="_blank">Prendre RDV en boutique</a>
      </div>
    </footer>

  </dialog>



</template>

<script setup>

import { ref } from 'vue';
import { onMounted, computed, nextTick, onBeforeUnmount } from 'vue';
import DOMPurify from 'dompurify';
import { taggage,taggageRecap } from '@/utils/taggage.js';
import { globalStore } from '@/utils/store.js';

globalStore.tag.tealium_event = "cart_add";

const props = defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  tag: Object
});

const data_etape5 = ref({});
const error_etape5 = ref(null);
const heightRecap = ref(0);
const isRecapActive = ref(false);

const emit = defineEmits(['switchToEtape1','switchToEtape2','switchToEtape3','switchToEtape4','switchToEtape5']);

const typePrice = ["field_prix_card", "field_prix_silver", "field_prix_gold", "field_prix_platine", "field_prix_elite"];

// Récupérer le premier packopen sélectionnés
const packopen = computed(() => {
  if (!data_etape5.value.packopen) return null;
  const keys = Object.keys(data_etape5.value.packopen);
  if (keys.length == 0) return null;
  return data_etape5.value.packopen[keys[0]]; // le premier forfait
});


// Récupérer le premier forfait et service sélectionnés
const forfaitSelection = computed(() => {
  if (!data_etape5.value.forfaitselection) return null;
  const keys = Object.keys(data_etape5.value.forfaitselection);
  if (keys.length == 0) return null;
  return data_etape5.value.forfaitselection[keys[0]]; // le premier forfait
});

const serviceSelection = computed(() => {
  if (!data_etape5.value.serviceselection) return null;
  const keys = Object.keys(data_etape5.value.serviceselection);
  if (keys.length == 0) return null;
  return data_etape5.value.serviceselection[keys[0]]; // le premier forfait
});
const mobile = computed(() => forfaitSelection.value?.field_avec_mobile || 0);

// Etiquettes mobile
const etiquetteMobile = [
  'Vous ne souhaitez pas un mobile à tarif préférentiel',
  'Vous souhaitez un mobile à tarif préférentiel',
];



// Prix après remise pour le forfait
const prixRemisePercent = computed(() => {
  if (!forfaitSelection.value) return 0;
  const prix = parseFloat(forfaitSelection.value.field_prix_forfait || 0);
  //console.log('prixRemisePercent prix : ' + prix);
  const remise = parseFloat(forfaitSelection.value.field_remise_en_du_forfait || 0);
  //console.log('prixRemisePercent remise : ' + remise);
  let result = remise > 0 ? prix - (prix * remise) / 100 : prix;
  for (const key in data_etape5.value.forfaitadditionnelsforme) {
    const additionnelprix = parseFloat(data_etape5.value.forfaitadditionnelsforme[key].field_prix_forfait || 0);
    const additionnelremise = parseFloat(data_etape5.value.forfaitadditionnelsforme[key].field_remise_en_du_forfait || 0);
    let resutladd = additionnelremise > 0 ? additionnelprix - (additionnelprix * additionnelremise) / 100 : additionnelprix;
    data_etape5.value.forfaitadditionnelsforme[key]['prixremisepercent'] = resutladd;
    if (data_etape5.value.forfaitadditionnelsforme[key].field_remise_forfait_additionnel) {
      data_etape5.value.forfaitadditionnelsforme[key]['promoprice'] =  (resutladd - parseFloat(data_etape5.value.forfaitadditionnelsforme[key].field_remise_forfait_additionnel)) * data_etape5.value.forfaitadditionnelsforme[key].multiple;
      data_etape5.value.forfaitadditionnelsforme[key]['promoprice2'] =  (parseFloat(data_etape5.value.forfaitadditionnelsforme[key].field_prix_forfait) - parseFloat(data_etape5.value.forfaitadditionnelsforme[key].field_remise_forfait_additionnel)) * data_etape5.value.forfaitadditionnelsforme[key].multiple;
    } else {
      data_etape5.value.forfaitadditionnelsforme[key]['promoprice'] =  resutladd * data_etape5.value.forfaitadditionnelsforme[key].multiple;
      data_etape5.value.forfaitadditionnelsforme[key]['promoprice2'] =  resutladd * data_etape5.value.forfaitadditionnelsforme[key].multiple;
    }
  }
  for (const key in data_etape5.value.forfaitadditionnelsforyou) {
    const additionnelprixyou = parseFloat(data_etape5.value.forfaitadditionnelsforyou[key].field_prix_forfait || 0);
    const additionnelremiseyou = parseFloat(data_etape5.value.forfaitadditionnelsforyou[key].field_remise_en_du_forfait || 0);
    let resutladdyou = additionnelremiseyou > 0 ? additionnelprixyou - (additionnelprixyou * additionnelremiseyou) / 100 : additionnelprixyou;
    data_etape5.value.forfaitadditionnelsforyou[key]['prixremisepercent'] = resutladdyou;
    if (data_etape5.value.forfaitadditionnelsforyou[key].field_remise_forfait_additionnel) {
      data_etape5.value.forfaitadditionnelsforyou[key]['promoprice'] =  (resutladdyou - parseFloat(data_etape5.value.forfaitadditionnelsforyou[key].field_remise_forfait_additionnel)) * data_etape5.value.forfaitadditionnelsforyou[key].multiple;
      data_etape5.value.forfaitadditionnelsforyou[key]['promoprice2'] =  (parseFloat(data_etape5.value.forfaitadditionnelsforyou[key].field_prix_forfait) - parseFloat(data_etape5.value.forfaitadditionnelsforyou[key].field_remise_forfait_additionnel)) * data_etape5.value.forfaitadditionnelsforyou[key].multiple;
    } else {
      data_etape5.value.forfaitadditionnelsforyou[key]['promoprice'] =  resutladdyou * data_etape5.value.forfaitadditionnelsforyou[key].multiple;
      data_etape5.value.forfaitadditionnelsforyou[key]['promoprice2'] =  resutladdyou * data_etape5.value.forfaitadditionnelsforyou[key].multiple;
    }
  }
  //console.log('check3');
  //console.log('PACKOPEN:'+packopen.value.nid);
  return result;
});

function getAdditionnelPromoprice(forfait) {
  const prix = parseFloat(forfait.field_prix_forfait || 0);
  const remisePct = parseFloat(forfait.field_remise_en_du_forfait || 0);
  const prixApremise = remisePct > 0 ? prix - (prix * remisePct) / 100 : prix;
  if (forfait.field_remise_forfait_additionnel) {
    return (prixApremise - parseFloat(forfait.field_remise_forfait_additionnel)) * forfait.multiple;
  }
  return prixApremise * forfait.multiple;
}

const totalRemiseAdditionnelForme = computed(() => {
  let totaladditionnelprice = 0;
  for (const key in data_etape5.value.forfaitadditionnelsforme) {
    totaladditionnelprice = totaladditionnelprice + (data_etape5.value.forfaitadditionnelsforme[key].field_remise_forfait_additionnel * data_etape5.value.forfaitadditionnelsforme[key]['multiple']);
  }
  return totaladditionnelprice;
});

const totalRemiseAdditionnelForyou = computed(() => {
  let totaladditionnelprice = 0;
  for (const key in data_etape5.value.forfaitadditionnelsforyou) {
    totaladditionnelprice = totaladditionnelprice + (data_etape5.value.forfaitadditionnelsforyou[key].field_remise_forfait_additionnel * data_etape5.value.forfaitadditionnelsforyou[key]['multiple']);
  }
  return totaladditionnelprice;
});

const totalAdditionnelPrice = computed(() => {
  let totaladditionnelprice = 0;
  for (const key in data_etape5.value.forfaitadditionnelsforme) {
    totaladditionnelprice = totaladditionnelprice + (data_etape5.value.forfaitadditionnelsforme[key]['promoprice'] * data_etape5.value.forfaitadditionnelsforme[key]['multiple']);
  }
  /*
  for (const key in data_etape5.value.forfaitadditionnelsforyou) {
    totaladditionnelprice = totaladditionnelprice + (data_etape5.value.forfaitadditionnelsforyou[key]['promoprice'] * data_etape5.value.forfaitadditionnelsforyou[key]['multiple']);
  }
  */
  return totaladditionnelprice;
});

const totalAdditionnelPrice2 = computed(() => {
  let totaladditionnelprice2 = 0;
  for (const key in data_etape5.value.forfaitadditionnelsforme) {
    totaladditionnelprice2 = totaladditionnelprice2 + (data_etape5.value.forfaitadditionnelsforme[key]['promoprice2'] * data_etape5.value.forfaitadditionnelsforme[key]['multiple']);
  }
  /*
  for (const key in data_etape5.value.forfaitadditionnelsforyou) {
    totaladditionnelprice2 = totaladditionnelprice2 + (data_etape5.value.forfaitadditionnelsforyou[key]['promoprice2'] * data_etape5.value.forfaitadditionnelsforyou[key]['multiple']);
  }
  */
  return totaladditionnelprice2;
});

const totalPromoPrice = computed(() => {
  let totalpromoprice = 0;
  for (const key in data_etape5.value.forfaitadditionnelsforme) {
    if (data_etape5.value.forfaitadditionnelsforme[key].field_remise_forfait_additionnel) {
      totalpromoprice = totalpromoprice + (data_etape5.value.forfaitadditionnelsforme[key].field_remise_forfait_additionnel * data_etape5.value.forfaitadditionnelsforme[key].multiple);
    }
  }
  return totalpromoprice;
});




// Prix après remise pour le service
const prixServiceRemisePercent = computed(() => {
  if (!serviceSelection.value) return 0;
  //console.log('check9');
  const prix = parseFloat(serviceSelection.value.field_prix_service || 0);
  //console.log('prixServiceRemisePercent prix : ' + prix);
  const remise = parseFloat(serviceSelection.value.field_remise_en_pourcentage || 0);
  //console.log('prixServiceRemisePercent remise : ' + remise);
  return remise > 0 ? prix - (prix * remise) / 100 : prix;
});


// Prix original
const orgPrice = computed(() => {
  return (parseFloat(forfaitSelection.value?.field_prix_forfait || 0) +
          parseFloat(serviceSelection.value?.field_prix_service || 0));
});



// Prix total avec remises pack
const price = computed(() => {
  if (!data_etape5.value.packopen) return 0;
  //console.log('prixRemisePercent : ' + prixRemisePercent.value);
  //console.log('prixServiceRemisePercent : ' + prixServiceRemisePercent.value);
  let total = prixRemisePercent.value + prixServiceRemisePercent.value;
  //console.log('total1 : ' + total);
  for (const key in data_etape5.value.packopen) {
    const packopenit = data_etape5.value.packopen[key];
    total -= parseFloat(packopenit.field_remise || 0);
    //console.log('remise : ' + packopenit.field_remise);
    //console.log('total2 : ' + total);
    if (packopenit?.field_deuxieme_remise) {
      //console.log('field_deuxieme_remise : ' + packopenit?.field_deuxieme_remise);
      total -= parseFloat(packopenit?.field_deuxieme_remise);
      //console.log('total3 : ' + total);
    }
  }
  //console.log('total : ' + total);
  return total;
});


const price2 = computed(() => {
  if (!forfaitSelection.value || !serviceSelection.value || !packopen.value) return 0;

  let prix = 0;
  if (forfaitSelection.value.field_remise_en_du_forfait > 0)
    prix = orgPrice.value - packopen.value.field_remise;

  if (serviceSelection.value.field_remise_en_pourcentage > 0)
    prix = orgPrice.value - packopen.value.field_remise;

  if (packopen.value?.field_deuxieme_remise)
    prix = orgPrice.value - packopen.value.field_remise;

  //console.log('price2 : ' + prix + '//' + orgPrice.value);

  return prix;
});


// Indicateur deuxième remise
const premiereRemise = computed(() => {
  if (!data_etape5.value.packopen) return 0;
  let total = 0;
  for (const key in data_etape5.value.packopen) {
    const packopenit = data_etape5.value.packopen[key];
    if (packopenit?.field_remise) {
      total = packopenit.field_remise * 12
    }
  }
  //console.log('total : ' + total);
  return total;

  /*
  if (!packopen.value.field_remise) return 0;
  return (packopen.value.field_remise * 12);
  */

});


const deuxiemeRemise = computed(() => {
  if (!data_etape5.value.packopen) return 0;
  let total = 0;
  for (const key in data_etape5.value.packopen) {
    const packopenit = data_etape5.value.packopen[key];
    if (packopenit?.field_deuxieme_remise && packopenit?.field_duree_deuxieme_remise) {
      total = (packopenit.field_deuxieme_remise * packopenit.field_duree_deuxieme_remise);
    }
  }
  //console.log('total : ' + total);
  return total;

  /*
  if (!packopen.value.field_deuxieme_remise) return 0;
  if (!packopen.value.field_duree_deuxieme_remise) return 0;
  return (packopen.value.field_deuxieme_remise * packopen.value.field_duree_deuxieme_remise);
  */
});


const totalRemise = computed(() => {
  return  (premiereRemise.value + deuxiemeRemise.value);
});


const cleanedMention1 = computed(() => {
  if (!packopen.value.field_mentions_remise) return "";
  else {
    return DOMPurify.sanitize(packopen.value.field_mentions_remise, {
      ALLOWED_TAGS: ['span', 'br', 'sup', 'b', 'i', 'strong']
    });
  }
});


const cleanedMention2 = computed(() => {
  if (!packopen.value.field_mentions_2eme_remise) return "";
  else {
    return DOMPurify.sanitize(packopen.value.field_mentions_2eme_remise, {
      ALLOWED_TAGS: ['span', 'br', 'sup', 'b', 'i', 'strong']
    })
  }
});


const duree = computed(() => {
  if (!packopen.value || !forfaitSelection.value || !serviceSelection.value) return 0;

  // Priorité 1 : packOpen
  if (packopen.value.field_duree_deuxieme_remise > 0) {
    return packopen.value.field_duree_deuxieme_remise;
  }

  // Priorité 2 : serviceSelection
  if (
    serviceSelection.value?.field_remise_en_pourcentage > 0 &&
    serviceSelection.value?.field_duree_de_la_remise_en_pour
  ) {
    return serviceSelection.value.field_duree_de_la_remise_en_pour;
  }

  // Priorité 3 : forfaitSelection
  if (
    forfaitSelection.value?.field_remise_en_du_forfait > 0 &&
    forfaitSelection.value?.field_duree_de_la_remise_en
  ) {
    return forfaitSelection.value.field_duree_de_la_remise_en;
  }

  // Sinon défaut
  return 0;
});

const taggagePack = computed(() => {

  var tag = { tealium_event: 'cart_add',
              offre_id: [packopen.value.nid],
              offre_marque: ['XXXX'],
              offre_type: ['XXXXX'],
              offre_modele: ['XXXX'],
              offre_quantite: [1],
              offre_libelle: [(packopen.value.title).replace(/\s+/g, '_')],
              offre_prix_ttc: [(price.value + totalAdditionnelPrice.value)]
            };


 return tag;

});

function jsModale(scroll) {
  const modale = document.querySelector('.jsModale2');
  modale.showModal();
  modale.querySelector('.jsModaleClose').addEventListener('click', closeModale);
  modale.addEventListener('click', e => closeModal(e));
  // On laisse le temps à la modale de s'afficher
  if (scroll != 'none') {
    setTimeout(() => {
      const target = modale.querySelector(`#${scroll}`);
      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
      } else {
        console.warn(`Ancre "${scroll}" non trouvée dans la modale`);
      }
    }, 100); // 100ms pour laisser le rendu s'effectuer
  }
}

function closeModale(e) {
  const modale = e.currentTarget.parentElement.parentElement;
  modale.close();
  e.target.removeEventListener('click', closeModale);
}

function closeModal(e) {
    //console.log('close Modal');
    const modale = document.querySelector('.jsModale2');

    const modaleHeader = modale.querySelector('header');
    const modaleContent = modale.querySelector('section');
    const modaleFooter = modale.querySelector('footer');

    modale.querySelector('.jsModaleClose').addEventListener('click', function() {
      //console.log('Croix Modale');
      modale.close();
      modale.removeEventListener('click', closeModal);
    });

    if (modaleHeader.contains(e.target) || modaleContent.contains(e.target)) {
      //console.log('close Modal 1');
      return;
    } else {
      //console.log('close Modal 2');
      modale.close();
      modale.removeEventListener('click', closeModal);
    }
}

function loadDialog(scroll) {
  //console.log('loadDialog');
  /*
  var livebox = event.target;
  console.log(livebox.dataset.liveboxid);
  liveboxDescription.value = data_etape4.value.liveboxes[livebox.dataset.liveboxid].field_description_longue;
  liveboxTitle.value = data_etape4.value.liveboxes[livebox.dataset.liveboxid].title;
  */
  jsModale(scroll);
};

function recapIsActive() {

  //console.log('recapIsActive');

  const el = document.getElementById('poRecap');
  if (el) {
    const hasActive = el.classList.contains('isActive');
    isRecapActive.value = hasActive;
    //console.log('recapIsActive:' + hasActive);
  }

}

function onExternalClickDone() {
  //console.log('✅ externalClickDone capté dans Vue');
  recapIsActive();
}

function hideTool() {
  props.parcours.hideTool = 1;
}

onMounted(async () => {
  try {
    //console.log('Etape5Recap mounted');
    const params = new URLSearchParams({
      mobile: props.parcours.mobile,
      forfait: props.parcours.forfait,
      typeconnexion: props.parcours.connexion,
      typeforfait: props.parcours.livebox,
      multilignes: JSON.stringify(props.parcours.multilignes),
      parcours: JSON.stringify(props.parcours)
    });

    const res = await fetch(`/packopenv3/etape5?${params}`);
    if (!res.ok) throw new Error(`Erreur HTTP ${res.status}`);
    data_etape5.value = await res.json();

    await nextTick();

    const packOpenRecap = document.querySelector('#poRecap');
    if (packOpenRecap) { packOpen(packOpenRecap); }

    const onyx4 = document.getElementById('packopenv3-4blocs');
    onyx4.style.display = 'none';
    const best = document.getElementById('packopenv3-bestsell');
    best.style.display = 'none';

    const element = document.getElementById('poRecap__header');
    if (element) {
      heightRecap.value = element.offsetHeight; // hauteur en pixels
    }

    window.addEventListener('externalClickDone', onExternalClickDone);

    closeMe();

  } catch (e) {
    error_etape5.value = e.message;
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('externalClickDone', onExternalClickDone)
  //console.log('👂 listener externalClickDone supprimé');
});

</script>
